var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.4188V24.6422",
    stroke: "url(#paint0_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.5878C17.5863 30.5878 18.8723 29.3018 18.8723 27.7155C18.8723 26.1292 17.5863 24.8432 16 24.8432C14.4137 24.8432 13.1277 26.1292 13.1277 27.7155C13.1277 29.3018 14.4137 30.5878 16 30.5878Z",
    stroke: "url(#paint1_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8777 28.0878C29.464 28.0878 30.75 26.8018 30.75 25.2155C30.75 23.6292 29.464 22.3432 27.8777 22.3432C26.2913 22.3432 25.0054 23.6292 25.0054 25.2155C25.0054 26.8018 26.2913 28.0878 27.8777 28.0878Z",
    stroke: "url(#paint2_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7434 18.4188V22.7321C21.7434 24.1036 22.8553 25.2155 24.2268 25.2155H24.8803",
    stroke: "url(#paint3_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12231 28.0878C5.70865 28.0878 6.99463 26.8018 6.99463 25.2155C6.99463 23.6292 5.70865 22.3432 4.12231 22.3432C2.53598 22.3432 1.25 23.6292 1.25 25.2155C1.25 26.8018 2.53598 28.0878 4.12231 28.0878Z",
    stroke: "url(#paint4_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2567 18.4188V22.7321C10.2567 24.1036 9.14478 25.2155 7.77322 25.2155H7.11972M25.9095 5.94283C24.6323 3.26208 21.9207 1.41214 18.7818 1.41214C15.9346 1.41214 13.4388 2.93426 12.0465 5.21789C11.6066 5.10074 11.1534 5.04157 10.6982 5.04189C7.78678 5.04189 5.42653 7.42927 5.42653 10.3742C5.42653 11.0128 5.53753 11.6253 5.74109 12.1928C4.64947 12.6894 3.8894 13.799 3.8894 15.0883C3.8894 16.8408 5.29397 18.2616 7.02665 18.2616H24.9735C26.7061 18.2616 28.1107 16.8408 28.1107 15.0883C28.1107 13.7991 27.3507 12.6894 26.2591 12.1928",
    stroke: "url(#paint5_linear_58_1185)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_1185",
    x1: 15.9945,
    y1: 21.5305,
    x2: 17.0055,
    y2: 21.5305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_1185",
    x1: 13.096,
    y1: 27.7155,
    x2: 18.904,
    y2: 27.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_1185",
    x1: 24.9737,
    y1: 25.2155,
    x2: 30.7817,
    y2: 25.2155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_1185",
    x1: 21.7261,
    y1: 21.8172,
    x2: 24.8977,
    y2: 21.8172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_1185",
    x1: 1.21831,
    y1: 25.2155,
    x2: 7.02634,
    y2: 25.2155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_1185",
    x1: 3.75578,
    y1: 13.3139,
    x2: 28.2444,
    y2: 13.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtime);
export default __webpack_public_path__ + "static/media/Realtime.7b4253ab23628710b97d9277b0082adf.svg";
export { ForwardRef as ReactComponent };